module.exports = __webpack_public_path__ + "img/CATEGORY ICON-18.7e18571e.png";